import Residence from './Residence';

export default Residence;
